import { useState } from "react";
import "./Menue.css";
import { NavLink } from "react-router-dom";
import logo from "../../components/images/logo.png"

const Menue = ({openMenu, checkMenu, dark}) => {

   

    return <div className="menueWrapper">

        {!openMenu && 
        <h1
            onClick={checkMenu}
            style={
                dark
                ? {
                    backgroundColor: "#272727",
                    color: "#000",
                    boxShadow:
                        "0 8px 20px rgba(0,0,0,0.35), 0 2px 6px rgba(255,255,255,0.08) inset",
                    }
                : {
                    backgroundColor: "#f8f8f8ff",
                    color: "white",
                    boxShadow:
                        "0 8px 24px rgba(0, 0, 0, 0.14), 0 2px 6px rgba(214, 214, 214, 0.9) inset",
                    }
            }
            >
            <p style={{backgroundColor: "blue", width: "25px", height: "3px", borderRadius: "4px"}}></p>
            <p style={{backgroundColor: "yellow", width: "25px", height: "3px", borderRadius: "4px"}}></p>
            <p style={{backgroundColor: "red", width: "25px", height: "3px", borderRadius: "4px"}}></p>
            </h1>}

    </div>
}

export default Menue;